<template>
  <div class="lms-layout-top-bar">
    <span class="btn-content pull-left">
      <Button type="text" v-if="showBackButton" @click="handleBackClick"><icon
        type="ios-arrow-back"></icon>&nbsp;&nbsp;{{l('FANHUI')}}</Button>
    </span>
    <ButtonGroup v-for="(action,index) in actions" class="btn-content" :key="index">
      <template v-for="subAction in action">
        <template v-if="!subAction.workflowBusinessType">
          <Button type="text"
                    :type="butttonType?butttonType:subAction.type"
                    v-if="subAction.vIf!=undefined?subAction.vIf:true"
                    @click="handleClick(subAction.actionId)" :disabled="IsDisabled(subAction)">
            <i v-if="subAction.icon"
               :class="subAction.icon"></i>&nbsp;&nbsp;{{subAction.display}}
          </Button>
        </template>
        <template v-else>
          <workflow-button
            type="text"
            :type="butttonType?butttonType:subAction.type"
            v-if="subAction.vIf!=undefined?subAction.vIf:true"
            :workflowBusinessType="subAction.workflowBusinessType"
            :businessId="subAction.businessId"
            :onSave="subAction.onSave"
            :onPublish="subAction.onPublish"
            :onAuditing="subAction.onAuditing"
            :onRemoteCompeleted="subAction.onRemoteCompeleted"
            :disabled="IsDisabled(subAction)">
            <i v-if="subAction.icon"
               :class="subAction.icon"></i>&nbsp;&nbsp;
            {{subAction.display}}
          </workflow-button>
        </template>
      </template>

    </ButtonGroup>
  </div>
</template>


<script>
  export default {
    name: "lms-toolbar",
    props: {
      actions: {
        type: Array,
        default: function () {
          return []
        }
      },
      showBackButton: {
        type: Boolean,
        default: false
      },
      backButtonClick: {
        type: Function
      },
      size: {
        type: String,
        default: "medium"
      },
      butttonType: {
        type: String,
        default: null
      }
    },
    methods: {
      handleClick(actionId) {
        this.$emit('toolbarClick', actionId);
      },
      handleBackClick() {
        if (this.backButtonClick) {
          this.backButtonClick();
        } else {
          if (this.$route.meta.funName) {
            this.$router.push({name: this.$route.meta.funName})
          } else {
            this.$router.go(-1);
          }
        }
      },
      getBtnClass(action) {
        if (action.type) {
          return "btn btn-" + action.type;
        }
        return "btn btn-light";
      },
      IsDisabled(action) {
        if (action.disabled === true) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

</script>


<style lang="less">
  .lms-layout-top-bar {
    height: 40px;
    width: 100%;
    background: white;
    position: absolute;
    left: 0;
    top: 0;
    border-bottom: 1px solid #dededb;
    text-align: right;

    .btn-content {
      margin: 4px 5px auto 5px;

    }

    .btn-content:first-child {
      margin-left: 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// Toolbar.vue?e7f8fa68